module.exports = __webpack_public_path__ + "img/zhyl.6dfda2ca.png";